import templateStr from 'text!./templates/quote-policy-box.html';

export default ['$filter', function ($filter) {
    var labelIDCounter = 0; // counter to allow for unique labels to be created for radio buttons

    return {
        restrict: 'A',
        scope: {
            buy: '=',
            quote: '=gwQnbQuotePolicyBox',
            loading: '='
        },
        template: templateStr,
        controller: ['$scope', function (scope) {
            scope.labelIDCounter = labelIDCounter++;
            scope.paymentPeriod = 'fullTerm';

            scope.buyLabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.Buy Now');
            scope.buyInFullLabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.X Months', {
                termMonths: scope.quote.premium.termMonths
            });

            scope.buyQuote = function () {
                var termInMonths = scope.paymentPeriod === 'fullTerm' ? scope.quote.premium.termMonths : 1;
                scope.buy(scope.quote, termInMonths);
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/QuotePolicyBox.js
// module id = 854
// module chunks = 0